import React from 'react';
import QualityCheckAnswerEdit from 'dashboard/qualityChecks/components/QualityCheckAnswerEdit';
import FaPlusCircle from 'react-icons/lib/fa/plus-circle';
import Colors from 'util/Colors';

const QualityCheckAnswerList = (props) => {
  const { DeterministicQualityCheck = { Answers: [] }, customQualityCheck = false } = props.currentRecord;

  return (
    <div className="quality-check-answers-list">
      <div>
        {DeterministicQualityCheck.Answers.map((answer, index) =>
          <QualityCheckAnswerEdit
              {...props}
              key={index}
              customQualityCheck = {customQualityCheck}
              deleteAnswer={() => deleteAnswer(props, index)}
              updateAnswerField={(field, value) =>
                updateAnswerField(props, answer, index, field, value)
              }
              currentAnswer={answer}
            ></QualityCheckAnswerEdit>
        )}
          <span className="top10">
            <FaPlusCircle
              style={{color: Colors.lightBlue, position: 'relative', top: -2}}
              className= "font-size-18 cursor-pointer"
              onClick={() => addAnswer(props)}
            />
            <span
              onClick={() => addAnswer(props)}
              className="left10 font-size-18 purple cursor-pointer"
            >
              Add answer
            </span>
          </span>
      </div>
    </div>
  );
};

function addAnswer(props) {
  const { DeterministicQualityCheck = { Answers: [] } } = props.currentRecord;
 props.updateState({
    currentRecord: {
      ...props.currentRecord,
      DeterministicQualityCheck: {
        ...DeterministicQualityCheck,
        Answers: [
          ...DeterministicQualityCheck.Answers,
          {
            AnswerText: ''
          },
        ],
      },
    },
  });
}

function updateAnswerField(props, answer, index, field, value) {
  const { DeterministicQualityCheck = { Answers: [] } } = props.currentRecord;
  const updatedAnswers = [
    ...DeterministicQualityCheck.Answers.slice(0, index),
    { ...answer, [field]: value },
    ...DeterministicQualityCheck.Answers.slice(index + 1),
  ];
  props.updateState({
    currentRecord: {
      ...props.currentRecord,
      DeterministicQualityCheck: {
        ...DeterministicQualityCheck,
        Answers: updatedAnswers,
      },
    },
  });
}

function deleteAnswer(props, index) {
  const { DeterministicQualityCheck = {  } } = props.currentRecord;
  const {Answers = []} = DeterministicQualityCheck;
  const {AnswerCustomData = {}} = Answers[index];

  if(Answers[index].NextQC || AnswerCustomData.PartnerNextQC) {
    return props.displayMessage({
      'messageType': 'warning',
      'messageCode': 'Can not delete this answer as it includes a link to next Quality Check',
    });
  }
  props.updateState({
    currentRecord: {
      ...props.currentRecord,
      DeterministicQualityCheck: {
        ...DeterministicQualityCheck,
        Answers: [
          ...Answers.slice(0, index),
          ...Answers.slice(index + 1),
        ],
      },
    },
  });
}

export default QualityCheckAnswerList;
